import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import { connectModal } from 'redux-modal';

class CNamePopup extends Component {
  render() {
    const { show, cname, handleHide } = this.props;
    return (
      <Modal show={show} onHide={handleHide}>
        <Modal.Header>
          <Modal.Title>CNAME Setup Instructions - {cname.domain}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ul style={{ paddingLeft: 15, listStyle: 'none', lineHeight: 1.7 }}>
            <li>
              <h3>1. Log into your domain host</h3>
              <p>Your domain host is typically where you purchased your domain name (like GoDaddy, Enom, or Name.com).</p>
            </li>
            <li>
              <h3>2. Add the CNAME record to your domain’s DNS records</h3>
              <p>Please follow the instructions below to add the CNAME record to your domain’s DNS records that are stored with your domain host.</p>
              <ol style={{ paddingLeft: 15 }}>
                <li>Go to your domain’s DNS records.</li>
                <li>
                  Choose to add a record to your DNS settings, and select <strong>CNAME</strong> as the record type.
                </li>
                <li>
                  Paste <strong>&apos;jdx&apos;</strong> into the <strong>Label</strong> or <strong>Host</strong> field with your DNS records.
                </li>
                <li>
                  Paste <strong>&apos;{`${cname.uuid}.jobadx.com`}&apos;</strong> into the <strong>Destination</strong> or
                  <strong>Target</strong> field with your DNS records. Your record should look like the one in the table below:
                  <p className="text-center">
                    <strong>CNAME Record</strong>
                  </p>
                  <div className="react-bs-container-body">
                    <table className="table table-hover table-bordered">
                      <thead>
                        <tr>
                          <th>Record type</th>
                          <th>Label/Host field</th>
                          <th>Time To Live (TTL)</th>
                          <th>Destination/Target field</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td className="text-center">CNAME</td>
                          <td className="text-center">jdx</td>
                          <td className="text-center">3600 or leave the default</td>
                          <td className="text-center">{`${cname.uuid}.jobadx.com`}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </li>
                <li>Save your record. CNAME record changes can take up to 72 hours to go into effect, but typically they happen much sooner.</li>

                <li>You&apos;ll be notified via email once you&apos;re CNAME becomes active.</li>
              </ol>
              <p>&nbsp;</p>
              <p>
                <small>
                  <strong>Note:</strong> See your domain host’s Help section for more specific instructions.
                </small>
              </p>
            </li>
          </ul>
        </Modal.Body>
      </Modal>
    );
  }
}

const CnamePopModal = connectModal({
  name: 'CnamePopModal',
});

export default CnamePopModal(CNamePopup);
